import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import AddNew from "./AddNew";
import { subjects } from "../layouts/subjects";
const SubjectList = (props) => {
  const [subject, setSubject] = useState("");
  const onChange = (e) => {
    setSubject(e.target.value);
  };
  const setClass = () => {
    props.setSub(subject.split("-")[0]);
  };
  const clearClass = () => {
    setSubject("");
    props.setSub("");
  };
  return (
    <form>
      <div className='form-group'>
        <label htmlFor='subjectList' className='fontcool'>
          Subject
        </label>
        <input
          value={subject}
          list='browsers'
          onChange={onChange}
          id='subjectList'
          className='form-control simplefont text-center'
          data-placement='right'
          placeholder='Choose subject'
        />
        <datalist id='browsers'>
          {subjects.BTech.map((item) => (
            <option value={item} />
          ))}
        </datalist>
      </div>

      <div className='form-group row d-flex justify-content-end'>
        <div className='col-6 col-md-3 col-xl-2 '>
          <input
            type='button'
            className='btn btn-block btn-dark slantfont'
            value='Get Lecture List'
            onClick={setClass}
          />
        </div>
        <div className='col-6 col-md-3 col-xl-2'>
          {" "}
          <input
            type='button'
            className='btn btn-block btn-outline-danger slantfont'
            value='Clear Class List'
            onClick={clearClass}
          />
        </div>
      </div>
    </form>
  );
};

export default SubjectList;
